import * as React from 'react';
import { Fragment, Component } from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { ReadMoreLessOptions } from '../models/configuration/components/ReadMoreLessOptions';
import ReadMoreLess from './ReadMoreLess';
import { DataStore } from '../stores';
import { computed } from 'mobx';
import { utils } from '@kurtosys/ksys-app-template';
import { Theme } from '../models/Theme';

const CommentaryContent = styled<any, any>(
    'div',
    'commentaryContent',
    'commentaries'
)`
    ${propStyles};
`;

CommentaryContent.defaultProps = {
    fontSize: 'sm',
    fontFamily: 'body',
    fontWeight: 'normal',
    lineHeight: '1.4',
    color: 'body',
    listStyle: 'none',
    marginY: 'md',
};

interface CommentariesProps {
    theme?: Theme;
    dataStore?: DataStore;
    commentaries: Array<string>;
    showReadMoreLess?: boolean;
    readMoreLessOptions?: ReadMoreLessOptions;
}

@inject('dataStore')
@observer
class Commentaries extends Component<CommentariesProps> {
    @computed
    get hasReadMoreCommentary(): boolean {
        const { readMoreLessOptions } = this.props;
        return (
            readMoreLessOptions &&
            !utils.typeChecks.isNullOrEmpty(
                readMoreLessOptions.readMoreCommentaries
            )
        );
    }

    @computed
    get commentaryContent() {
        const {
            theme,
            commentaries = [],
            showReadMoreLess = false,
            readMoreLessOptions,
            dataStore,
            ...props
        } = this.props;

        return commentaries.map((commentary, index) => (
            <CommentaryContent
                key={index}
                dangerouslySetInnerHTML={{ __html: commentary }}
                {...theme.CommentaryContent}
                {...props}
            />
        ));
    }
    @computed
    get readMoreCommentaryContent(): React.ReactNode {
        const {
            theme,
            commentaries = [],
            showReadMoreLess = false,
            readMoreLessOptions,
            dataStore,
            ...props
        } = this.props;

        if (readMoreLessOptions && readMoreLessOptions.readMoreCommentaries) {
            return readMoreLessOptions.readMoreCommentaries.map(
                (commentary, idx) => {
                    return (
                        <CommentaryContent
                            key={idx}
                            dangerouslySetInnerHTML={{ __html: commentary }}
                            {...theme.CommentaryContent}
                            {...props}
                        />
                    );
                }
            );
        }
        return null;
    }

    render() {
        const {
            commentaries = [],
            showReadMoreLess = false,
            readMoreLessOptions,
            dataStore,
        } = this.props;

        return commentaries.length > 0 ? (
            <Fragment>
                {showReadMoreLess && !dataStore.isMobile ? (
                    <ReadMoreLess
                        readMoreLessOptions={readMoreLessOptions}
                        readMoreCommentary={this.readMoreCommentaryContent}
                    >
                        {this.commentaryContent}
                    </ReadMoreLess>
                ) : (
                    <Fragment>
                        {this.commentaryContent}
                        {this.hasReadMoreCommentary &&
                            this.readMoreCommentaryContent}
                    </Fragment>
                )}
            </Fragment>
        ) : null;
    }
}

export default withTheme(Commentaries);



// WEBPACK FOOTER //
// ./src/Components/Commentaries.tsx